import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/library/:libraryItemId/document`;

export type GetLibraryItemDetailsResponse = {
  status: boolean;
  data: any;
};

export type GetLibraryItemDetailsDTO = {
  libraryItemId: number;
};

export type GetLibraryItemDetailsParams = {
  page: number;
  inTrash?: boolean;
  limit: number;
};

export const getLibraryItemDetailsQueryKey = {
  list: ['getLibraryItemDetails'] as const,
};

export const getLibraryItemDetails = ({
  libraryItemId,
}: GetLibraryItemDetailsDTO): Promise<GetLibraryItemDetailsResponse> => {
  const URL = generateRoutePath(url, { libraryItemId });

  return axios.get(URL);
};
type QueryFnType = typeof getLibraryItemDetails;

type UseGetLibraryItemDetailsOptions = {
  libraryItemId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLibraryItemDetails = ({
  libraryItemId,
  config,
}: UseGetLibraryItemDetailsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...getLibraryItemDetailsQueryKey.list, libraryItemId],
    queryFn: () => getLibraryItemDetails({ libraryItemId }),
    select: (data) => {
      return {
        ...data,
        data: {
          id: data.data.id,
          file: {
            id: data.data.id,
            name: data.data['file-origin'],
            rawName: data.data['file-name'],
          },
          isDeleted: false,
          isActive: true,
          from: data.data['created-by'],
          createdDate: data.data['created-date'],
          fileSize: data.data['file-size-bytes'],
        },
      };
    },

    // staleTime: Infinity,
    cacheTime: 0,
    ...config,
  });
};
